// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_addUnifiedDisplayMember(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedProfileConversionCommitted",
    "UnifiedProfileConversionOutcomeUnknown",
    "UnifiedProfileNotUnifiedError",
    "UnifiedProfileUpdateFailed",
    "UpdateUnifiedAccountProfilePayload"
  ]);
}

let variablesConverter = {"unifiedProfileSocialInput":{},"unifiedProfileImageInput":{},"unifiedProfileAddDisplayMemberInput":{"social":{"r":"unifiedProfileSocialInput"},"originalImage":{"r":"unifiedProfileImageInput"},"image":{"r":"unifiedProfileImageInput"}},"__root":{"input":{"r":"unifiedProfileAddDisplayMemberInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"addUnifiedDisplayMember_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"addUnifiedDisplayMember":{"u":"response_addUnifiedDisplayMember"}}};

let wrapResponseConverterMap = {
  response_addUnifiedDisplayMember: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"addUnifiedDisplayMember_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"addUnifiedDisplayMember":{"u":"response_addUnifiedDisplayMember"}}};

let responseConverterMap = {
  response_addUnifiedDisplayMember: unwrap_response_addUnifiedDisplayMember
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "GIF" || $$enum === "WEBP" || $$enum === "JPEG" || $$enum === "PNG") {
    return $$enum;
  }
}

let imageContentType_fromString = imageContentType_decode;

let Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileNotUnifiedError",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileConversionCommitted",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileConversionOutcomeUnknown",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "width",
        "value": 48
      }
    ],
    "kind": "ScalarField",
    "name": "url",
    "storageKey": "url(width:48)"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addUnifiedDisplayMember",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "UnifiedProfileSave_updatedMembers"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "addUnifiedDisplayMember",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isAccountProfile"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 100
                          }
                        ],
                        "concreteType": "TeamAccountProfileMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamAccountProfileMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Agent",
                                        "kind": "LinkedField",
                                        "name": "agent",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                          },
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProfilePhoto",
                                            "kind": "LinkedField",
                                            "name": "profilePhoto",
                                            "plural": false,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          },
                                          (v8/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "role",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "visibility",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "UserBoundMember",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProfilePhoto",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": (v10/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DisplayOnlyMember",
                                    "abstractKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "members(first:100)"
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cfebcf7ee6086aa02a5ade3a7442bfa7",
    "id": null,
    "metadata": {},
    "name": "UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation(\n  $input: UnifiedProfileAddDisplayMemberInput!\n) {\n  addUnifiedDisplayMember(input: $input) {\n    __typename\n    ... on UpdateUnifiedAccountProfilePayload {\n      __typename\n      profile {\n        __typename\n        ...UnifiedProfileSave_updatedMembers\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n    ... on UnifiedProfileNotUnifiedError {\n      message\n    }\n    ... on UnifiedProfileConversionCommitted {\n      message\n    }\n    ... on UnifiedProfileConversionOutcomeUnknown {\n      message\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n\nfragment UnifiedProfileSave_updatedMembers on AccountProfile {\n  __isAccountProfile: __typename\n  __typename\n  ... on TeamAccountProfile {\n    nodeId\n    members(first: 100) {\n      edges {\n        node {\n          __typename\n          ... on UserBoundMember {\n            nodeId\n            ...UnifiedTeamAccountProfileMemberRow_userMember\n          }\n          ... on DisplayOnlyMember {\n            nodeId\n            ...UnifiedTeamAccountProfileMemberRow_displayOnlyMember\n          }\n          ... on Node {\n            __isNode: __typename\n            __typename\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_displayOnlyMember on DisplayOnlyMember {\n  nodeId\n  displayName\n  title\n  profilePicture {\n    url(width: 48)\n  }\n}\n\nfragment UnifiedTeamAccountProfileMemberRow_userMember on UserBoundMember {\n  nodeId\n  agent {\n    id\n    displayName\n    profilePhoto {\n      url(width: 48)\n    }\n    nodeId\n  }\n  role\n  title\n  visibility\n}\n"
  }
};
})());

let wrap_response_addUnifiedDisplayMember = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_addUnifiedDisplayMember = unwrap_response_addUnifiedDisplayMember;
exports.wrap_response_addUnifiedDisplayMember = wrap_response_addUnifiedDisplayMember;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
